/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const MainContainerStyled = styled.div`
  ${() => css`
    height: 100%;
    display: flex;
    flex-direction: row;
    transition: background-color 0.3s ease;
    overflow: hidden;

    & > .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 0;
      overflow-x: hidden;

      & > *:nth-of-type(2) {
        overflow: auto;

        @media screen and (max-width: 1200px) {
          padding-top: 1rem;
        }

        @media screen and (max-width: 768px) {
          padding-top: 0.5rem;
        }
      }
    }
  `}
`;
